(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // 【核心避坑】因为这个卡片文件会被循环加载多次，用这个判断确保这组 JS 全局只执行一次！
    if (!window.productCardAnimationInited) {
      window.productCardAnimationInited = true;

      let index2 = 1;
      // 选取所有的商品卡片
      const elements2 = document.querySelectorAll('.product-card');
      
      for (const element of elements2) {
        const content = element.textContent.trim();
        
        // 如果内容为空，跳过这个空卡片，继续处理下一个！（强烈建议用 continue 代替 break）
        if (!content) {
            continue; 
        }
        
        // 添加动画类名
        element.classList.add('animate__animated');
        element.classList.add('animate__backInLeft');
        
        // 动态计算并设置动画延迟时间
        element.style.setProperty('animation-delay', (index2 * 0.3 + 1) + 's', 'important');
        
        index2++;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
